import React, { useCallback, useMemo, useState, useEffect, } from "react";
import { TabContext } from "./TabContext";
import { bem, use, classnames } from "../../lib";
export const Tabs = ({ onChange, activeTab, children, compact, className, }) => {
    const [state, setState] = useState({
        activeTab,
    });
    useEffect(() => {
        setState((state) => (Object.assign(Object.assign({}, state), { activeTab })));
    }, [activeTab]);
    const onTabClick = useCallback((name) => {
        if (onChange)
            onChange(name);
    }, [onChange]);
    const context = useMemo(() => {
        const ctx = {
            state,
            setState,
            onTabClick,
            compact,
        };
        return ctx;
    }, [onTabClick, state, setState, compact]);
    return (React.createElement(TabContext.Provider, { value: context },
        React.createElement("div", { className: classnames(className, bem("tabs", use(compact, "--compact"))) }, children)));
};
//# sourceMappingURL=Tabs.js.map